export const MODAL_STEP_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
    START: 'start',
} as const;